import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout, { FullPageSpinner } from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Saldo from "./pages/Saldo";
import Laporan from "./pages/Laporan";
import Rekap from "./pages/Rekap";
import Kategori from "./pages/Kategori";
import Anggaran from "./pages/Anggaran";
import ImportExcel from "./pages/ImportExcel";
import ExportPage from "./pages/ExportPage";
import Pengaturan from "./pages/Pengaturan";
import KhususAdmin from "./pages/KhususAdmin";
import DisplayDashboard from "./pages/DisplayDashboard";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import AuditTrail from "./pages/AuditTrail";
import Profile from "./pages/Profile";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function ProtectedBare({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (!user) return children; // DisplayDashboard menangani tampilan login sendiri
  return children;
}

function RequirePerm({ perm, children }) {
  const { user } = useAuth();
  const perms = user?.permissions || [];
  const need = [].concat(perm);
  if (!need.some((p) => perms.includes(p))) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/display" element={<ProtectedBare><DisplayDashboard /></ProtectedBare>} />
          <Route element={<Protected />}>
            <Route path="/" element={<RequirePerm perm="view_dashboard"><Dashboard /></RequirePerm>} />
            <Route path="/pemasukan" element={<RequirePerm perm="view_income"><Transactions type="income" /></RequirePerm>} />
            <Route path="/pengeluaran" element={<RequirePerm perm="view_expense"><Transactions type="expense" /></RequirePerm>} />
            <Route path="/transaksi" element={<RequirePerm perm="view_transactions"><Transactions type="all" /></RequirePerm>} />
            <Route path="/saldo" element={<RequirePerm perm="view_balance"><Saldo /></RequirePerm>} />
            <Route path="/laporan" element={<RequirePerm perm="view_reports"><Laporan /></RequirePerm>} />
            <Route path="/rekap" element={<RequirePerm perm="view_reports"><Rekap /></RequirePerm>} />
            <Route path="/anggaran" element={<RequirePerm perm="view_budget"><Anggaran /></RequirePerm>} />
            <Route path="/kategori" element={<RequirePerm perm="manage_categories"><Kategori /></RequirePerm>} />
            <Route path="/import" element={<RequirePerm perm="import_excel"><ImportExcel /></RequirePerm>} />
            <Route path="/export" element={<RequirePerm perm={["export_excel", "export_reports"]}><ExportPage /></RequirePerm>} />
            <Route path="/pengaturan" element={<RequirePerm perm="manage_settings"><Pengaturan /></RequirePerm>} />
            <Route path="/khusus-admin" element={<RequirePerm perm="view_special_expense"><KhususAdmin /></RequirePerm>} />
            <Route path="/pengguna" element={<RequirePerm perm="view_users"><Users /></RequirePerm>} />
            <Route path="/roles" element={<RequirePerm perm="manage_roles"><Roles /></RequirePerm>} />
            <Route path="/audit" element={<RequirePerm perm="view_audit_log"><AuditTrail /></RequirePerm>} />
            <Route path="/profil" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
